var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"value":_vm.value,"clearable":"","placeholder":"请选择"},on:{"input":_vm.change}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.content,"value":item.value}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }